export const LogicTypeParam = "PARAM";

export const LogicTypeOptions = [
	{ value: LogicTypeParam, label: "inputs" }
];
